<template>
  <div>
    <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
    <Button type="info" class="margin-top" icon="ios-redo" @click="back">返回上一页</Button>

    <Modal
      v-model="modal1"
      title="选择角色"
      @on-ok="add"
      @on-cancel="guanbi">
<!--      <Select v-model="role" prefix="md-person">-->
<!--        <Option v-for="item in roleList" :value="item" :key="item.id">{{ item.name }}</Option>-->
<!--      </Select>-->
      <el-select v-model="role" placeholder="请选择后台角色" style="width: 100%">
        <el-option v-for="(item,index) in roleList" :label="item.name" :key="index" :value="item.id"></el-option>
      </el-select>
    </Modal>

    <xc-model :loading="isModel" title="激活刀具柜" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">卡号：</div>
            <input type="text" v-model="kahao" placeholder="请输入刀具柜卡号" class="djt20">
          </div>
          <div class="djt23">
            <div class="djt19">激活：</div>
            <div class="djt24">
              <el-switch
                class="djt25"
                v-model="isCheck"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="sure()">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "userInfo",
    data() {
      return {
        isModel:false,
        loading: false,           //是否加载列表
        columns7: [
          {
            title: '公司名称',
            key: 'companyName',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.companyName)
              ]);
            }
          },
          {
            title: '后台角色',
            key: 'roleName'
          },
          {
            title: '操作',
            key: 'action',
            width: 500,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'md-build'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.toDjg(params.index)
                    }
                  }
                }, '刀具柜激活'),
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'md-person-add'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '选择角色'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                    icon:'ios-pricetags'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.tags(params.index)
                    }
                  }
                }, '标签'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon:'ios-walk'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delCom(params.index)
                    }
                  }
                }, '踢出'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon:'md-cloud-done'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.seaQx(params.index)
                    }
                  }
                }, '刀具柜权限'),
              ]);
            }
          }
        ],
        data6: [],
        userId:'',                //传过来的用户ID
        modal1:false,             //是否显示选择模块
        role:[],                  //选择的角色
        roleList: [],
        item:[],                  //选中的item
        index:0,                  //选中的下标
        isCheck:false,
        kahao:'',
        is_dis:false,
        djg:[],
      }
    },
    created() {
      var me = this;
      if (me.$route.query.hasOwnProperty('userId')) {
        me.userId = me.$route.query.userId;
      }
      me.loading = true;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        companyId:'',
        userId:me.userId,
        mobile:user.mobile,
        sign:user.sign,
      }
      httpUser.userInfo(data).then(res => {
        console.log(res);
        me.data6 = res.data;
        me.loading = false;
      })
    },
    methods:{
      sure(){//确认激活或修改
        var me = this;
        if (me.kahao == '') {
          me.$message.error('请输入卡号');
          return false;
        }
        if (util.isSpace(me.kahao)) {
          me.$message.error('卡号不能含有空格');
          return false;
        }
        if (util.checkNofh(me.kahao)) {
          me.$message.error('卡号不能含有符号');
          return false;
        }
        let data = {
          id:me.djg.id,
          cardno:me.kahao,
        }
        if (me.isCheck == true) {
          data['activestate'] = 1;
        } else {
          data['activestate'] = 2;
        }
        me.$Loading.start();
        httpUser.activecard(data).then(res => {
          switch (res.code) {
            case "0000":
              me.isModel = false;
              me.$Loading.finish();
              me.$message.success('修改成功');
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('该卡号已存在');
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('修改失败');
              break;
          }
        })
      },
      toDjg(index){//前往刀具柜激活
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let user = JSON.parse(sessionStorage.getItem('user'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','用户激活');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        if (user.companyId != me.data6[index].companyId) {
          me.$message.error('无权限修改用户其他公司');
          return false;
        }
        let data = {
          companyid:me.data6[index].companyId,
          userid:me.userId,
        }
        me.$Loading.start();
        httpUser.activecarddetail(data).then(res => {
          console.log(res);
          if (res.data.datalist.cardno == null) {
            me.kahao = '';
            me.isCheck = false;
            me.isModel = true;
            // me.is_dis = false;
          } else {
            me.kahao = res.data.datalist.cardno;
            if (res.data.datalist.activestate == 1) {
              me.isCheck = true;
            } else {
              me.isCheck = false;
            }
            // me.is_dis = true;
            me.isModel = true;
          }
          me.djg = res.data.datalist;
          me.$Loading.finish();
        })
      },
      cancel(){//添加框点击返回
        var me = this;
        me.isModel = false;
      },
      tags(index){
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let user = JSON.parse(sessionStorage.getItem('user'));
        let is_auth = util.is_Auth(menu,'用户管理','查看用户标签');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        if (user.companyId != me.data6[index].companyId) {
          me.$message.error('无权限修改用户其他公司');
          return false;
        }
        me.$router.push({name:'userLabel',params:{companyId:me.data6[index].companyId,userId:me.data6[index].id}})
      },
      back(){
        this.$router.back();
      },
      edit(index){
        var me = this;
        me.index = index;
        me.item = me.data6[index];
        me.$Loading.start();
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'用户管理','分配角色');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          me.$Loading.error();
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user.companyId != 1 && user.companyId != me.item.companyId) {
          me.$message.error('无权限修改用户其他公司');
          me.$Loading.error();
          return false;
        }
        let data = {
          companyId:me.item.companyId,
          userId:'',
          mobile:user.mobile,
          sign:user.sign
        }
        httpUser.getRole(data).then(res => {
          me.roleList = res.data;
          me.$Loading.finish();
          me.modal1 = true;
        })
      },
      guanbi(){//关闭模态框
        var me = this;
        me.item = [];
        me.role = [];
        me.modal1 = false;
      },
      add(){//用户点击确定
        var me = this;
        me.$Loading.start();
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          companyId:me.item.companyId,
          userId:me.userId,
          mobile:user.mobile,
          sign:user.sign,
          roleId:me.role,
          type:0
        }
        httpUser.setRole(data).then(res => {
          switch (res.code) {
            case '0000':
              let data = {
                companyId:'',
                userId:me.userId,
                mobile:user.mobile,
                sign:user.sign,
              }
              httpUser.userInfo(data).then(res => {
                console.log(res);
                me.data6 = res.data;
                me.role = [];
                me.item = [];
                me.$Loading.finish();
                me.$message.success('分配成功');
              })
              break;
            case '1111':
              me.$Loading.error();
              me.$message.error('分配失败');
              break;
            case '1100':
              me.$Loading.error();
              me.$message.error('设备管理人员，不能设为采购');
              break;
            case '1105':
              me.$Loading.error();
              me.$message.error('超级管理员不能修改');
              break;
            case '1101':
              me.$Loading.error();
              me.$message.error('设备维修人员，不能为采购');
              break;
          }
        })
      },
      seaQx(index){/*查看用户刀具柜领取权限*/
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'刀具柜管理','查看领取权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user.companyId != 1 && user.companyId != me.data6[index].companyId) {
          me.$message.error('无权查看其它公司');
          return false;
        }
        me.$router.push({path:'/djgqx',query:{userId:me.userId,companyId:me.data6[index].companyId}})
      },
      delCom(index){//踢出公司
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'公司管理','踢出公司');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user.companyId != 1 && user.companyId != me.data6[index].companyId) {
          me.$message.error('无权限修改用户其他公司');
          return false;
        }
        me.$confirm('此操作将永久踢出该公司, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          if (user.companyId != me.data6[index].companyId) {
            me.$message.error('无权限踢出其他公司');
            me.$Loading.error();
            return false;
          }
          let data = {
            userId: me.userId,
            sign: user.sign,
            companyId: me.data6[index].companyId,
            mobile:user.mobile
          };
          httpUser.delCom(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('踢出成功');
                me.$Loading.finish();
                break;
              case '1001':
                me.$message.error('app角色为管理员');
                me.$Loading.error();
                break;
              case '1003':
                me.$message.error('此用户在此公司的设备有管理员或维修人员身份');
                me.$Loading.error();
                break;
              case '1002':
                me.$message.error('后台角色为系统默认');
                me.$Loading.error();
                break;
            }
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>